// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PPieChartOutlinedSvg from "@fishx/icons-svg/es/asn/PPieChartOutlined";
import FishxIcon from '../components/FishxIcon';

var PPieChartOutlined = function PPieChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PPieChartOutlinedSvg
  }));
};

PPieChartOutlined.displayName = 'PPieChartOutlined';
export default React.forwardRef(PPieChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PPieChartOutlined.js
// module id = 3540
// module chunks = 0